import { TILE_SIZE } from '@veriverse/shared';
import { tileId } from '../model.js';
import { type TiledMap, type TiledTileset } from '../types.js';

export interface TileSource {
  readonly tileset: TiledTileset;
  /** Pixel rectangle of the tile inside the tileset image. */
  readonly sx: number;
  readonly sy: number;
  readonly size: number;
}

/** Where a gid is found: its tileset and pixel rectangle. `undefined` for 0 or unknown ids. */
export function tileSource(map: TiledMap, gid: number): TileSource | undefined {
  const id = tileId(gid);
  if (id === 0) return undefined;
  let owner: TiledTileset | undefined;
  for (const set of map.tilesets) {
    if (
      id >= set.firstgid &&
      id < set.firstgid + set.tilecount &&
      (!owner || set.firstgid > owner.firstgid)
    ) {
      owner = set;
    }
  }
  if (!owner) return undefined;
  const local = id - owner.firstgid;
  const column = local % owner.columns;
  const row = Math.floor(local / owner.columns);
  return {
    tileset: owner,
    sx: owner.margin + column * (owner.tilewidth + owner.spacing),
    sy: owner.margin + row * (owner.tileheight + owner.spacing),
    size: TILE_SIZE,
  };
}

/** Every selectable tile of a tileset as `{ gid }`, for the tile picker. */
export function tilesetGids(set: TiledTileset): number[] {
  return Array.from({ length: set.tilecount }, (_, i) => set.firstgid + i);
}
